import { DialogOptions } from '../../../models/modal.model'
import {
  GenericNotificationCode,
  NotificationOptions,
  parseGenericNotification,
} from '../../../models/notification.model'
import { Product } from '../product.model'

export type ProductNotificationCode =
  | GenericNotificationCode
  | 'PRODUCT_DELETED'
  | 'PRODUCT_NOT_FOUND'

export type ProductModalCode = 'PRODUCT_DELETION'

/**
 * Parse product code to a notification
 * @param code - the product notification code
 * @returns the notification options
 */
export function parseProductNotification(
  code?: ProductNotificationCode,
): NotificationOptions {
  switch (code) {
    case 'PRODUCT_DELETED':
      return {
        message: 'Product deleted successfully',
        color: 'success',
      }
    case 'PRODUCT_NOT_FOUND':
      return {
        message: 'Product not found',
        color: 'error',
      }
    default:
      return parseGenericNotification(code)
  }
}

/**
 * Parse product code to an modal
 * @param code - the product modal code
 * @param Product - the product object
 * @returns the modal settings
 */
export function parseProductModal(
  code: ProductModalCode,
  product?: Product,
): DialogOptions {
  switch (code) {
    case 'PRODUCT_DELETION': {
      const prSku = product?.SKU
      return {
        title: 'Delete product',
        message:
          'You are about to delete the product <strong>%s</strong>. Proceed with deletion?',
        messageParams: prSku ? [prSku] : undefined,
        buttons: ['Cancel', 'Confirm'],
      }
    }
    default:
      return {}
  }
}
